import moment from "moment";
import { SCORE_TYPES, OPTION_TYPES } from '../../../../utils/const'

export function getFullScore(tir) {
    let fullScore = ''
    if (tir && SCORE_TYPES.includes(tir.type)) {
      fullScore = `（${tir.fullScore}分）`
    }
    return fullScore
}

export function getDuplicateLose (tir) {
    return tir && tir.losePoint === 2 ? '重复失分项' : ''
}

export function getResult(tir) {
    if (tir.phoneIsNa) {
        return "NA"
    }
    if (SCORE_TYPES.includes(tir.type)) {
        if (tir.scoreContent) {
            tir.isScore = false
            return tir.scoreContent
        }
        if (Array.isArray(tir.options) && tir.options.length) {
            let selectedOptions = tir.options.reduce((arr, item) => {
                if (item.state == 1 || tir.score === item.score) {
                    arr.push(item.name)
                }
                return arr
            }, [])
            if (selectedOptions.length) {
                tir.isScore = false
                return selectedOptions.join("、")
            }
        }
    }
    tir.isScore = true
    return tir.result
}

export function getTimeStr(val) {
    return moment(val).format("YYYY/MM/DD HH:mm")
}

export function joinNames(val) {
    let names = ""
    Array.isArray(val) && val.forEach((item, index) => {
        if (index > 0) names += "、"
        names += item.name
    })
    return names
}